<script>
    export default {
        props: {
            initLmsConnection: {
                type: Object,
                required: false,
            }
        },
        data() {
            return {
                companyId: this.initLmsConnection?.company_id || 0,
                lmsConnectionId: this.initLmsConnection?.id || 0,
                lmsConnections: [],
            };
        },
        watch: {
            companyId() {
                this.loadLmsConnections();
            },
        },
        mounted() {
            if (this.lmsConnectionId) {
                this.loadLmsConnections(this.lmsConnectionId);
            }
        },
        methods: {
            loadLmsConnections(selectedLmsConnectionId) {
                this.lmsConnections = [];
                this.lmsConnectionId = selectedLmsConnectionId || 0;
                this.loading = true;

                axios.get(
                    this.route('companies.lms-connections', {company: this.companyId})
                ).then(response => {
                    this.lmsConnections = response.data;
                    this.loading = false;
                });
            }
        },
    };
</script>
